import { useNow } from "../hooks/useNow";
import { ecc } from "../lib/data";
import { useFirestoreCollection } from "../hooks/useFirestoreCollection";
import { formatRel, minutesNow } from "../lib/time";
import { setChecklistItem, getMelderString } from "../lib/firestore-ops";
import { Icon } from "./Icon";
import type { ChecklistEntry } from "../lib/types";

export function EccTimeline() {
  const now = useNow(30_000);
  const nowMin = minutesNow(now);
  const { data: checklist } = useFirestoreCollection<ChecklistEntry>(
    "checklist",
  );
  const checkMap = new Map(checklist.map((c) => [c.id, c]));

  return (
    <ul className="space-y-1.5">
      {ecc.map((e) => {
        const isPast = e.vanMin != null && nowMin >= e.vanMin;
        const entry = checkMap.get(e.id);
        const checked = entry?.checked ?? false;
        return (
          <li
            key={e.id}
            className={`card px-3 py-2.5 flex items-center gap-3 ${
              checked
                ? "opacity-60"
                : isPast
                  ? "border-warn/50"
                  : "border-line"
            }`}
          >
            <button
              onClick={() => setChecklistItem(e.id, !checked, getMelderString())}
              aria-label={`${checked ? "Vink uit" : "Vink af"}: ${e.wat}`}
              aria-pressed={checked}
              className="w-11 h-11 flex items-center justify-center shrink-0 active:bg-ink-700 rounded-lg"
            >
              <span
                className={`w-7 h-7 rounded-md border-2 flex items-center justify-center transition-colors ${
                  checked
                    ? "bg-ok border-ok text-ink-950"
                    : "border-line text-zinc-500"
                }`}
              >
                {checked && <Icon.Check className="w-4 h-4" />}
              </span>
            </button>
            <div className="w-14 shrink-0 text-sm font-mono tabular text-zinc-300">
              {e.tijd_van ?? "NTB"}
            </div>
            <div className="flex-1 min-w-0">
              <div
                className={`text-sm truncate ${
                  checked
                    ? "text-zinc-500 line-through"
                    : "font-medium text-zinc-100"
                }`}
              >
                {e.wat}
              </div>
              {e.aandachtspunten && (
                <div className="text-2xs text-zinc-500 mt-0.5 line-clamp-2">
                  {e.aandachtspunten}
                </div>
              )}
            </div>
            {!checked && e.vanMin != null && (
              <div
                className={`text-2xs tabular shrink-0 ${
                  isPast ? "text-warn" : "text-zinc-500"
                }`}
              >
                {formatRel(e.vanMin, nowMin)}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
